import { combineReducers } from 'redux';

import loadWireError from './loadWireError';
import editWireError from './editWireError';
import cancelWireError from './cancelWireError';
import loadWireFileError from './loadWireFileError';


export default combineReducers({
  loadWireError,
  editWireError,
  cancelWireError,
  loadWireFileError,
});
